import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../../../app.config';
import { catchErrorLogRet } from '../../../common/rest.operators';
import { GpPlaybook } from '../gp-playbook.model';

@Injectable({ providedIn: 'root' })
export class GamePlanService {
    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {}

    retrievePlaybook(userId: number): Observable<GpPlaybook | null> {
        return this._http
            .get(
                `${this._appConfig.API_ENDPOINTS.COACHING}/game-plan/${userId}/playbook`,
            )
            .pipe(catchErrorLogRet(null));
    }
}
